import {vNiveauEnum} from '../../core/model/nachricht/vniveau.enum';

export function handleStepUp(vNiveau: vNiveauEnum) {
  self.dispatchEvent(new CustomEvent('oiamLoginEvent', { detail: { authnLevel: vNiveau } }));
}
